import React from 'react';
import {Link, Redirect} from 'react-router-dom';
// utils
import {loggedIn} from '../utils';
// imgs
import pic1 from '../imgs/1.jpg';

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            error_msg: '',
            err: false
        }
    }
    onHandleLogin(e) {
        e.preventDefault()
        if (this.state.email == 'pjs' && this.state.password == 'ipo') {
            localStorage.setItem('login', true);
            this.props.history.push('/?login=true');
        } else {
            localStorage.setItem('login', false);
            this.setState({err: true, err_msg: 'Invalid email/password'})
        }
    }
    onHandleTypeEmail(e) {
        console.log(e.target.value)
        this.setState({
            email: e.target.value,
            err: false
        });
    }
    onHandleTypePassword(e) {
        
        console.log(e.target.value)
        this.setState({
            password: e.target.value,
            err: false
        })
    }
  render() {
    if (loggedIn()) {
        return <Redirect to="/" />
    } else {
        return (
          <div className="container frame">
            <div className="row">
                <div className="col-md-4 offset-md-4 col-sm-6 offset-sm-3">
                    {this.state.err ? <div class="alert alert-danger" role="alert">
                            {this.state.err_msg}
                        </div> : null}
                    <h3 className="login-title">Login</h3>
                    <form>
                        <div className="form-group">
                            <label htmlFor="exampleInputEmail1">Email address</label>
                            <input type="email" className="form-control" id="exampleInputEmail1" 
                                aria-describedby="emailHelp" placeholder="Enter email"
                                value={this.state.email} onChange={this.onHandleTypeEmail.bind(this)}/>
                        </div>
                        <div className="form-group">
                            <label htmlFor="exampleInputPassword1">Password</label>
                            <input type="password" className="form-control" id="exampleInputPassword1" 
                                placeholder="Password"
                                value={this.state.password} onChange={this.onHandleTypePassword.bind(this)}/>
                            <small id="emailHelp" className="form-text text-muted"><Link to="/">Forgot password?</Link></small>
                        </div>
                        <div className="form-group form-check">
                            <input type="checkbox" className="form-check-input" id="exampleCheck1"/>
                            <label className="form-check-label" htmlFor="exampleCheck1">Remember me</label>
                        </div>
                        <div className="form-group" style={{display: 'flex'}}>
                            <button type="submit" className="btn btn-primary"
                                onClick={this.onHandleLogin.bind(this)}
                                >Login</button>
                        </div>
                        <div>Don't have an account? <Link to="/signup">Sign up</Link></div>
                    </form>
                    <br/>
                </div>
            </div>
          </div>
          )
    }
  }
}

export default Login;